import { Component, Input } from '@angular/core';
import { CarVehicleStorage } from 'src/app/pages/campas/campas.component';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';
import { VehicleStorage } from 'src/app/pages/new-service/interfaces/VehicleStorage';

@Component({
  selector: 'app-summary-funnel-dialog',
  templateUrl: './summary-funnel-dialog.component.html',
  styleUrls: ['./summary-funnel-dialog.component.scss'],
})
export class SummaryFunnelDialogComponent {
  @Input() summaryData: SummaryData = {} as SummaryData;
  @Input() showVehicleStorageInfo: boolean = false;
  @Input() vehicleStorageOrigin: CarVehicleStorage | undefined = undefined;
  @Input() vehicleStorageDestination: VehicleStorage | undefined = undefined;
  constructor() {
  }
}
